export default "__VITE_ASSET__Ba1P6_Cy__"